import { useCallback } from 'react';
import { deriveVisibleNodeIds } from '../../utils/mindmap/branchVisibility';

/**
 * Custom hook for managing node visibility
 * Determines which nodes should be visible based on selection and hierarchy
 */
export const useVisibility = ({
  nodes,
  relationships,
  focusRootId,
  collapsedNodeIds,
  temporarilyExpandedNodeIds,
}) => {

  const getVisibleNodeIds = useCallback(() => {
    return deriveVisibleNodeIds({
      nodes,
      relationships,
      focusRootId,
      collapsedNodeIds,
      temporarilyExpandedNodeIds,
    });
  }, [nodes, relationships, focusRootId, collapsedNodeIds, temporarilyExpandedNodeIds]);

  const isNodeVisible = useCallback((nodeId) => {
    const visibleIds = getVisibleNodeIds();
    return visibleIds.has(nodeId);
  }, [getVisibleNodeIds]);

  const getVisibleNodes = useCallback(() => {
    const visibleIds = getVisibleNodeIds();
    return nodes.filter(node => visibleIds.has(node.id));
  }, [nodes, getVisibleNodeIds]);

  const getHiddenNodes = useCallback(() => {
    const visibleIds = getVisibleNodeIds();
    return nodes.filter(node => !visibleIds.has(node.id));
  }, [nodes, getVisibleNodeIds]);

  return {
    getVisibleNodeIds,
    isNodeVisible,
    getVisibleNodes,
    getHiddenNodes
  };
};
